import React, { useEffect, useState, useCallback } from "react";
import API, { ADD_USER_FAKE, LIST_USER_FAKE, EDIT_USER_FAKE, DELETE_USER_FAKE } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, Input, message, Table, Pagination, Modal } from "antd";
import ModalCommon from "../../components/Modal";

const TEXT = {
  stt: "STT",
  username: "Tên đăng nhập",
  actions: "Thao tác",
  edit: "Sửa",
  delete: "Xóa",
  confirmDelete: "Bạn có chắc chắn muốn xóa tài khoản fake này?",
  editUser: "Sửa tài khoản fake",
  newUsername: "Tên đăng nhập mới",
};

const { confirm } = Modal;

const TURNS_MIN = 1;   // random ngầm
const TURNS_MAX = 100; // random ngầm

const PopupFakeUserManager = () => {
  const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

  // form tạo mới
  const [username, setUsername] = useState("");
  
  // form sửa
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [newUsername, setNewUsername] = useState("");

  // list & paging
  const [dataList, setDataList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [loading, setLoading] = useState(false);

  // antd message
  const [messageApi, contextHolder] = message.useMessage();

  const locale = { emptyText: TEXT_DEF.text0035 };
  const showTotal = (total) => `Tổng cộng ${total} tài khoản`;
  const onChangePage = (p) => setPage(p);

  const showError = useCallback((msg) =>
    messageApi.open({ type: "error", content: msg || "Đã có lỗi xảy ra" }), [messageApi]);
  const showSuccess = useCallback((msg) =>
    messageApi.open({ type: "success", content: msg || "Thành công" }), [messageApi]);

  const randInt = (min, max) =>
    Math.floor(Math.random() * (max - min + 1)) + min;

  const getListData = useCallback(async () => {
    try {
      setLoading(true);
      const resp = await API.get(`${LIST_USER_FAKE}?pageSize=10&page=${page}`);
      const res = resp?.data?.data?.data;
      if (res) {
        const dataCV = res.map((item, idx) => ({
          key: item?.id ?? idx,
          stt: item?.id,
          username: item?.username,
        }));
        setDataList(dataCV);
        setTotalRecord(resp?.data?.data?.total ?? 0);
      }
    } catch (error) {
      console.log(error);
      showError(error?.response?.data?.message || "Không tải được danh sách");
    } finally {
      setLoading(false);
    }
  }, [page, showError]);

  useEffect(() => {
    getListData();
  }, [getListData]);

  const onCreateUserFake = async () => {
    try {
      if (!username || !username.trim()) {
        showError("Vui lòng nhập tên đăng nhập");
        return;
      }
      const turns = randInt(TURNS_MIN, TURNS_MAX); // random ngầm
      const body = { username: username.trim(), turns };

      const response = await API.post(`${ADD_USER_FAKE}`, body);
      if (response?.data) {
        setIsShowModalSuccess(true);
        showSuccess(`Tạo tài khoản fake thành công!`);
        setUsername("");
        await getListData();
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred";
      showError(errorMessage);
    }
  };

  const handleEditUser = (record) => {
    setEditingUser(record);
    setNewUsername(record.username);
    setIsEditModalVisible(true);
  };

  const handleUpdateUser = async () => {
    try {
      if (!newUsername || !newUsername.trim()) {
        showError("Vui lòng nhập tên đăng nhập");
        return;
      }

      // Generate turns như khi tạo mới
      const turns = randInt(TURNS_MIN, TURNS_MAX);
      const body = { 
        username: newUsername.trim(),
        turns: turns
      };
      
      const response = await API.patch(`${EDIT_USER_FAKE}/${editingUser.stt}`, body);
      
      if (response?.data) {
        showSuccess("Cập nhật tài khoản fake thành công!");
        setIsEditModalVisible(false);
        setEditingUser(null);
        setNewUsername("");
        await getListData();
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred";
      showError(errorMessage);
    }
  };

  const handleDeleteUser = (record) => {
    confirm({
      title: TEXT.confirmDelete,
      content: `Tài khoản: ${record.username}`,
      okText: "Xóa",
      okType: "danger",
      cancelText: "Hủy",
      onOk: async () => {
        try {
          const response = await API.delete(`${DELETE_USER_FAKE}/${record.stt}`);
          if (response?.data) {
            showSuccess("Xóa tài khoản fake thành công!");
            await getListData();
          }
        } catch (error) {
          const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            "An error occurred";
          showError(errorMessage);
        }
      },
    });
  };

  const dataColums = [
    {
      title: TEXT.stt,
      key: "stt",
      dataIndex: "stt",
      align: "center",
      render: (_text, _record, index) =>
        (page - 1) * 10 + index + 1,
    },
    {
      title: TEXT_DEF.text0002,
      dataIndex: "username",
      key: "username",
      align: "center",
    },
    {
      title: TEXT.actions,
      key: "actions",
      align: "center",
      render: (_, record) => (
        <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
          <Button 
            type="primary" 
            size="small" 
            onClick={() => handleEditUser(record)}
          >
            {TEXT.edit}
          </Button>
          <Button 
            type="primary" 
            danger 
            size="small" 
            onClick={() => handleDeleteUser(record)}
          >
            {TEXT.delete}
          </Button>
        </div>
      ),
    },
  ];

  const renderInputUsername = () => (
    <div className="flex col-8 flex-row w-full items-center justify-center mt-2 gap-4">
      <div className="col-8 flex flex-col items-center justify-center">
        <div className="flex w-full items-center">
          <div className="flex w-[20%] justify-end mr-10">{TEXT.username}:</div>
          <div className="w-[60%]">
            <Input
              value={username}
              style={{ width: "100%" }}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Nhập tên đăng nhập"
            />
          </div>
        </div>
      </div>
      <div className="col-2 flex flex-col items-center mt-1">
        <Button type="primary" onClick={onCreateUserFake} disabled={!username?.trim()}>
          Lưu
        </Button>
      </div>
    </div>
  );

  const renderTableUser = () => (
    <div className="flex w-full items-center justify-center flex-col">
      <div style={{ display: "flex", width: "100%", marginTop: 20 }}>
        <Table
          key="table-user-fake"
          locale={locale}
          columns={dataColums}
          dataSource={dataList}
          loading={loading}
          pagination={false}
          bordered
          style={{ width: "100%" }}
        />
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          marginTop: 15,
          justifyContent: "flex-end",
        }}
      >
        <Pagination
          current={page}
          total={totalRecord}
          onChange={onChangePage}
          defaultPageSize={10}
          showSizeChanger={false}
          showTotal={showTotal}
        />
      </div>
    </div>
  );

  return (
    <div className="col-12">
      {contextHolder}
      <div className="col-12">
        <div className="flex w-full">
          <div className="flex col-12 flex-col w-full items-center justify-center">
            {renderInputUsername()}
            <div style={{ fontWeight: 900, margin: 20 }}>
              --------------------------------------------
            </div>
            {renderTableUser()}
          </div>
        </div>
      </div>

      {isShowModalSuccess && (
        <ModalCommon
          isShow={isShowModalSuccess}
          message={"Tạo tài khoản fake thành công!"}
          txtBtnAcc={TEXT_DEF.text0007}
          actionNext={() => setIsShowModalSuccess(false)}
          close={() => setIsShowModalSuccess(false)}
        />
      )}

      <Modal
        title={TEXT.editUser}
        open={isEditModalVisible}
        onOk={handleUpdateUser}
        onCancel={() => {
          setIsEditModalVisible(false);
          setEditingUser(null);
          setNewUsername("");
        }}
        okText="Cập nhật"
        cancelText="Hủy"
      >
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: "block", marginBottom: 8 }}>{TEXT.newUsername}:</label>
          <Input
            value={newUsername}
            onChange={(e) => setNewUsername(e.target.value)}
            placeholder="Nhập tên đăng nhập mới"
          />
        </div>
      </Modal>
    </div>
  );
};

export default PopupFakeUserManager;
